import { gql } from '@apollo/client';

export const APPROVE_PAYMENTS = gql`
  mutation Mutation($input: BulkApproveInput) {
  bulkApprovePaymentsV2(input: $input)
}
`;
